export interface StockAtDateReport {
  id: string;
  stockNo: string;
  productType: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  balance: number;
  balanceImperial: number;
  pricePerUnit: number;
  value: number;
  warehouseKey: string;
  warehouseDescription: string;
  locationKey: string;
  locationDescription: string;
  gradeKey: string;
  gradeLevel: string;
  makeUpKey: string;
  makeUpDescription: string;
  batchNo: string;
  customerKey: string;
  customerName: string;
}
